import { Type } from 'react-bootstrap-table2-editor';
import store from '../../../../../store';
import { addTeamsError, clearUpdateTeamErrors } from '../../../../../Redux/Actions/Contract.Teams.Actions';
import * as Helpers from '../Helpers/DatatableHelpers';
import { dateEditRenderer } from '../Helpers/Editors';

const emailRegEx = new RegExp(/^(?!.{201})([\w\W-]+@([\w\W-]+\.)+[\w-]+)$/);

const MultiTeamInitialisation = templateData => [
	{ dataField: 'id', text: 'id', hidden: true },
	{ dataField: 'templateId', text: 'TemplateId', hidden: true },
	{
		dataField: 'templateName',
		text: 'Template Name',
		headerClasses: 'th-td-md',
		formatter: Helpers.templateFormatter,
		formatExtraData: { templateData },
		editor: {
			type: Type.SELECT,
			getOptions: () => templateData
		}
	},
	{
		dataField: 'contractReleaseDate',
		text: 'Release Date',
		headerClasses: 'th-td-md',
		formatter: Helpers.formatDateInput,
		editorRenderer: dateEditRenderer(null, 'Release Date'),
		validator: (newValue, row, column) => {
			let validator = Helpers.validateReleaseDate(newValue, row, column);
			if (!validator.valid) {
				store.dispatch(addTeamsError([`Release Date: ${validator.message}`]));
				validator.message = 'Field is invalid.';
			} else {
				store.dispatch(clearUpdateTeamErrors());
				validator.message = '';
			}
			return validator;
		}
	},
	{
		dataField: 'contractEndDate',
		text: 'End Date',
		headerClasses: 'th-td-md',
		formatter: Helpers.formatDateInput,
		editorRenderer: dateEditRenderer(null, 'End Date'),
		validator: (newValue, row, column) => {
			let validator = Helpers.validateEndDate(newValue, row, column);
			if (!validator.valid) {
				store.dispatch(addTeamsError([`End Date: ${validator.message}`]));
				validator.message = 'Field is invalid.';
			} else {
				store.dispatch(clearUpdateTeamErrors());
				validator.message = '';
			}
			return validator;
		}
	},
	{
		dataField: 'emailAddress',
		text: 'Team Email',
		headerClasses: 'th-td-md',
		validator: email => {
			let validator =
				email.length <= 0 ? { valid: true } : emailRegEx.test(email) ? { valid: true } : { valid: false, message: `Email Address is invalid` };
			if (!validator.valid) store.dispatch(addTeamsError([`Marking Team Email: ${validator.message}`]));
			return validator;
		}
	}
];

export default MultiTeamInitialisation;
